import MyFavoritesToggle from './components/MyFavoritesToggle.vue'

export default MyFavoritesToggle
